import { useMemo } from "react";
import { isValid } from "date-fns";

/**
 * Calculates maximum allowed date based on the given argument.
 * If an invalid date is provided, it adds 5 years to
 * the current date and returns it.
 * @param maxDate
 * @returns
 * A maximum allowed date.
 */
export function useMaxDate(maxDate) {
  const value = useMemo(() => {
    if (isValid(maxDate)) return maxDate;
    else {
      const today = new Date();
      return new Date(today.setFullYear(today.getFullYear() + 5));
    }
  }, [maxDate]);

  return value;
}
export default useMaxDate;
